module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1006-7bb83487b35a985f914f18d7315200d3.png";